import { apiClient } from 'api'
import { User } from 'types/users'
import { Role } from 'types/roles'

type NewItem = Omit<User, 'id'>

export const getRoles = () => apiClient.get<Role[]>('/roles')
